import { icon } from './lib/fa-icons.js';
import {
	sizeIframes,
	fullBleedImages,
	fivepointsHeads,
	figcaptionToggles,
	initAnnotations,
	arrangeMiniposts,
} from "tpm-lib/content-reinit.js";
$(self).ready(() => {
	// Content-scoped passes live in tpm-lib/content-reinit.js (shared with the
	// post-unlock swap re-run); the boot path runs them over the whole page.
	const env = {
		isMobile: !!self.is_mobile,
		singlePost: !!self.single_post,
		category: self.category,
	};
	sizeIframes($(".Article"), env);
	fullBleedImages(document, env);
	fivepointsHeads(document, env);
	figcaptionToggles(document);

	/**
	 * ArticleCollapse expander
	 *
	 */
	$(".js_article-content-collapse-toggle").on("click", function () {
		$(this).toggleClass("--collapse");
		$(".js_article-content-collapse").toggleClass("--collapse");
		if ($(this).hasClass("--collapse")) {
			document.querySelector(".js_article-content-collapse").scrollIntoView();
		}
	});

	/**
	 * article annotations
	 *
	 */
	const tpm_annotations_toggle = $(
		".js_annotations-toggle input[type=checkbox]"
	);
	const tpm_annotations = initAnnotations(document);
	// close annotations when you click outside of one
	$("body").on("click", function (event) {
		// if the target of the click isn't the container nor a descendant of the container
		if (
			!tpm_annotations.is(event.target) &&
			tpm_annotations.has(event.target).length === 0
		) {
			tpm_annotations.each(function () {
				$(this).removeClass("--visible");
			});
		}
	});

	if (tpm_annotations_toggle) {
		tpm_annotations_toggle.change(function () {
			if (!$(this).is(":checked")) {
				tpm_annotations.each(function () {
					$(this).addClass("--hidden");
				});
			} else {
				tpm_annotations.each(function () {
					$(this).removeClass("--hidden");
				});
			}
		});
	}

	/**
	 * info tooltips
	 */
	const tpm_infoTooltips = $(".js_info-tooltip");
	if (tpm_infoTooltips) {
		tpm_infoTooltips.each(function () {
			const self = $(this);
			if (self.hasClass("--hover")) {
				console.logI("eeeeee");
				self.mouseover(function () {
					self.addClass("--active");
					const tooltip = `<div class="js_info-tooltip-tip InfoTooltip__Tip">${icon('xmark', 'solid')}${self.data(
						"tooltip"
					)}</div>`;
					self.append(tooltip);
				});
				self.mouseleave(function () {
					self.removeClass("--active");
					const tooltip = self.find(".js_info-tooltip-tip");
					tooltip.remove();
				});
			} else {
				self.on("click", function () {
					if (!self.hasClass("--active")) {
						self.addClass("--active");
						const tooltip = `<div class="js_info-tooltip-tip InfoTooltip__Tip">${icon('xmark', 'solid')}${self.data(
							"tooltip"
						)}</div>`;
						self.append(tooltip);
					} else {
						self.removeClass("--active");
						const tooltip = self.find(".js_info-tooltip-tip");
						tooltip.remove();
					}
				});
			}
		});
		//if you click outside of a tooltip, close every tooltip
		$("body").on("click", function (event) {
			// if the target of the click isn't the container nor a descendant of the container
			if (
				!tpm_infoTooltips.is(event.target) &&
				tpm_infoTooltips.has(event.target).length === 0
			) {
				tpm_infoTooltips.each(function () {
					$(this).removeClass("--active");
					const tooltip = $(this).find(".js_info-tooltip-tip");
					tooltip.remove();
				});
			}
		});
	}

	/**
	 * Contribute/TPM Journalism Fund
	 * this stuff isn't running rn but im not deleting this js
	 *
	 */

	function hideWithCookie(component, button, cookie, days) {
		if ($("." + component)) {
			//reveal the component unless cookie is present
			if (!document.cookie.match("(^|;) ?" + cookie + "=([^;]*)(;|$)")) {
				$("." + component).css("display", "block");
			}

			$("." + button).on("click", function () {
				const d = new Date();
				//expires in 30 days
				d.setTime(d.getTime() + days * 24 * 60 * 60 * 1000);
				document.cookie = cookie + "=1;expires=" + d.toUTCString() + ";path=/";
				$("." + component).css("display", "none");
			});
		}
	}
	//if trial card is present...
	if ($(".js_join-trial-card").length) {
		//if trial card has been previously dismissed, show the journalism fund
		if (
			document.cookie.match(
				"(^|;) ?" + "tpmjointrialcardhide" + "=([^;]*)(;|$)"
			)
		) {
			hideWithCookie(
				"js_journalism-fund",
				"js_journalism-fund-hide",
				"tpmjournalismfundhide",
				30
			);
			//show the trial card
		} else {
			hideWithCookie(
				"js_join-trial-card",
				"js_join-trial-card-hide",
				"tpmjointrialcardhide",
				3
			);
		}
		//show the journalism fund if the trial card is NOT present
	} else {
		hideWithCookie(
			"js_journalism-fund",
			"js_journalism-fund-hide",
			"tpmjournalismfundhide",
			30
		);
	}

	//light obfuscation of sharetoken url, tpm_shared_with_token defined in single-prime.php
	if (window.tpm_shared_with_token) {
		let path = window.location.pathname.replace(/^\//, "");
		path = path.split("/");
		path = `${window.location.origin}/${path[0]}/${path[1]}`;
		window.history.pushState("", "", path);
	}

	if (typeof is_feature_meadows !== "undefined" && is_feature_meadows) {
		/* dropcap for feature-meadows template */
		const p = $(".entry-content-inner p.has-drop-cap");
		if (p.length) {
			const letter = p.html()[0];
			const html = p.html().substring(1);
			p.html(
				`<span class="dropcap">${letter}<img class="speech-bubble" src="${document.location.origin}/wp-content/themes/tpm25/assets/images/icons/speech-bubble.svg" aria-hidden="true"></span>${html}`
			);
		}

		/* auto-generated Initials Circles for iMessage style quotes */
		const bubbles = $(
			"blockquote.wp-block-quote.is-style-imessage-left, blockquote.wp-block-quote.is-style-imessage-right"
		);
		bubbles.each(function () {
			let name = $(this).find("cite").text();
			if (name === "Marjorie Taylor Greene") {
				$(this).append(`<span class="name-bubble">MTG</span>`);
			} else {
				name = name.split(" ");
				let firstInit = name[0][0];
				let lastInit = name[1][0];
				$(this).append(
					`<span class="name-bubble">${firstInit}${lastInit}</span>`
				);
			}
		});
	}

	/* if url contains an anchor link, scroll up 55px on page load */
	if (window.location.hash) {
		const hash = window.location.hash;
		const cleanHash = hash.startsWith('#') ? hash.slice(1) : hash;
		const target = document.querySelector(`[id="${cleanHash}"]`);
		if (target) {
			window.scrollTo({
				top: target.getBoundingClientRect().top + window.scrollY - 100,
			});
		}
	}

	/* if the user has adblocker on we hide taboola by default
		if they dont, the statement below will be true and we show taboola 
		and set the tag to "PAID PROMOTION"
	*/
	if (document.querySelector(".Taboola")) {
		setTimeout(() => {
			if (
				document.querySelector("#taboola-below-article-thumbnails").children
					.length > 0
			) {
				const taboola = document.querySelector(".Taboola");
				taboola.classList.add("--active");
				document.querySelector(".Taboola__Tag").textContent = "PAID PROMOTION";

				const adSlotRemove = document.createElement("div");
				adSlotRemove.className = "AdSlot__Remove Taboola__AdSlotRemove";
				adSlotRemove.textContent = "ADVERTISEMENT · ";

				const adFreeLink = document.createElement("a");
				adFreeLink.href = "/memberships";
				adFreeLink.textContent = "GO AD FREE";
				adSlotRemove.appendChild(adFreeLink);

				const taboolaThumbnails = document.querySelector(
					"#taboola-below-article-thumbnails"
				);
				taboolaThumbnails.insertBefore(
					adSlotRemove,
					taboolaThumbnails.firstChild
				);
			}
		}, 1000);
	}

	/* if article contains a minipost look for an "entry" query param. If it matches the id of a querypost on page, scroll to that */
	if (document.querySelector(".tpm-minipost-container")){
		const urlParams = new URLSearchParams(window.location.search);
		const entryId = urlParams.get("entry");
		if (entryId) {
			const entry = document.querySelector(`.tpm-minipost-container[id="${entryId}"]`);
			if (entry) {
				window.scrollTo({
					top: entry.getBoundingClientRect().top + window.scrollY - 100,
				});
			}
		}
	}

	/* minipost layout: author byline after the heading, copy-link inside it */
	arrangeMiniposts(document);
});
